"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var PublicSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M7,14.6585886 L7,12 C7,11.4477153 7.44771525,11 8,11 L9,11 C9.55228475,11 10,11.4477153 10,12 L12,12 C12.5522847,12 13,12.4477153 13,13 L13,13.472213 C14.2274987,12.3735719 15,10.7769996 15,9 C15,7.22300037 14.2274987,5.62642809 13,4.52778699 L13,5 C13,5.55228475 12.5522847,6 12,6 L11,6 C10.4477153,6 10,6.44771525 10,7 L10,8 C10,8.55228475 9.55228475,9 9,9 L8,9 L8,10 C8,10.5522847 7.55228475,11 7,11 L6,11 C5.44771525,11 5,10.5522847 5,10 L5,9 L3,9 C3,11.6124377 4.66961525,13.8349158 7,14.6585886 L7,14.6585886 Z M8,14.9170416 C8.32520847,14.9716012 8.65928779,15 9,15 C10.0928614,15 11.1174799,14.7078171 12,14.1973068 L12,13 L10,13 C9.44771525,13 9,12.5522847 9,12 L8,12 L8,14.9170416 L8,14.9170416 Z M3.08295844,8 L5,8 C5.55228475,8 6,8.44771525 6,9 L6,10 L7,10 L7,9 C7,8.44771525 7.44771525,8 8,8 L9,8 L9,7 C9,5.8954305 9.8954305,5 11,5 L12,5 L12,3.80269317 C11.1174799,3.29218286 10.0928614,3 9,3 C6.02700371,3 3.55903653,5.16228666 3.08295844,8 Z M9,16 C5.13400675,16 2,12.8659932 2,9 C2,5.13400675 5.13400675,2 9,2 C12.8659932,2 16,5.13400675 16,9 C16,12.8659932 12.8659932,16 9,16 Z" })));
};
PublicSmall.displayName = 'PublicSmall';
exports.default = PublicSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=PublicSmall.js.map